import BudgetPage from "pages/BudgetPage";
import "global.css";

function App() {
  return (
    <>
      <BudgetPage></BudgetPage>
    </>
  );
}

export default App;
